import React from 'react';
import SEO from '../components/SEO';
import ServiceLayout from '../components/ServiceLayout';

const MaintenancePage: React.FC = () => {
  return (
    <>
      <SEO
        title="Healthcare Equipment Support & Maintenance"
        description="Preventive maintenance, fleet servicing for mobile workstations, parts sourcing, and equipment relocation for healthcare facilities."
        keywords="healthcare equipment maintenance, hospital equipment support, mobile workstation fleet maintenance, preventive maintenance program, medical equipment repair"
        url="https://www.jvphealthtechsolutions.com/services/maintenance"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Healthcare Equipment Support & Maintenance",
          "description": "Preventive maintenance, fleet servicing for mobile workstations, parts sourcing, and equipment relocation for healthcare facilities.",
          "provider": { "@type": "Organization", "name": "JVP Health Tech Solutions" },
          "areaServed": "US"
        }}
      />
      <ServiceLayout
        title="Support & Maintenance"
        subtitle="Proactive maintenance and support to keep your equipment running reliably."
        pageImage="/images/services/repairs-12cbd313.jpg"
        pageImageAlt="Ongoing maintenance and support for hospital equipment"
        ctaText="Get Support Plan"
        summary="We don't disappear after installation. Our maintenance programs keep your equipment performing safely and reliably — preventing issues before they impact patient care."
        sections={[
          {
            title: 'Preventive Maintenance',
            body: 'Scheduled service that extends equipment life, reduces downtime, and keeps your facility compliant.',
            items: [
              'Mounting hardware, joints, and locking mechanism inspections',
              'Cable and connector integrity checks',
              'Height adjustment and articulation testing',
              'Cleaning and lubrication of moving components',
              'Documentation and compliance reporting',
              'Identification of wear items before they fail',
            ],
          },
          {
            title: 'Fleet & Cart Maintenance',
            body: 'Dedicated programs for mobile workstation fleets — keeping every cart in your unit operational and safe.',
            items: [
              'Scheduled fleet-wide inspections on a recurring cadence',
              'Battery health checks and replacement coordination',
              'Wheel, brake, and caster servicing',
              'Hardware repairs and component swaps',
            ],
          },
          {
            title: 'Parts & Relocation',
            body: 'When equipment needs parts or a new home, we handle it — sourcing genuine components and managing safe relocations.',
            items: [
              'Genuine replacement parts sourced through our provider network',
              'Mounting hardware, arm components, and cart accessories',
              'Equipment relocation when departments move or expand',
              'Reconfiguration and optimization for new room layouts',
            ],
          },
        ]}
      />
    </>
  );
};

export default MaintenancePage;
